import style from "./ListContainer.module.css";

const ListContainer = ({ children }) => {
    return (
        <div className={style.list_container}>{children}</div>
    );
}

export default ListContainer;